import { Component, OnInit } from '@angular/core';
import { URL_IMG } from '../../../constants/general';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent implements OnInit {
  url_img = URL_IMG;
  constructor() { }

  ngOnInit(): void {
  }

  showStateCircleOne():boolean {
    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'registro': 
          return true;
        break;
        case 'opciones/autonomo-identificacion': 
          return true;
        break;
        case 'opciones/autonomo-comprobante': 
          return true;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }
  }

  showStateCircleTwo():boolean {
    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'opciones/autonomo-completa-informacion': 
          return true;
        break;
        case 'opciones/autonomo-beneficiario': 
          return true;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }
  }

  showStateCircleThree():boolean {
    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'opciones/autonomo-confirmacion': 
          return true;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }
  }

  showStateLineOne():boolean {

    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'opciones/autonomo-identificacion': 
          return false;
        break;
        case 'opciones/autonomo-comprobante': 
          return true;
        break;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }    
  }

  showStateLineOneCheck():boolean {

    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'opciones/autonomo-completa-informacion': 
          return true;
        break;
        case 'opciones/autonomo-beneficiario': 
          return true;
        break;
        case 'opciones/autonomo-confirmacion': 
          return true;
        break;
        case 'opciones/autonomo-thank-you-page': 
          return true;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }    
  }

  showStateLineTwo():boolean {

    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'opciones/autonomo-confirmacion': 
          return true;
        break;
        case 'opciones/autonomo-thank-you-page': 
          return true;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }    
  }


  showStateCheckOne():boolean{
    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'opciones/autonomo-beneficiario': 
          return true;
        break;
        case 'opciones/autonomo-completa-informacion': 
          return true;
        break;
        case 'opciones/autonomo-confirmacion': 
          return true;
        break;
        case 'opciones/autonomo-thank-you-page': 
          return true;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }
  }

  showStateCheckTwo():boolean{
    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'opciones/autonomo-confirmacion': 
          return true;
        break;
        case 'opciones/autonomo-thank-you-page': 
          return true;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }
  }

  showStateCheckThree():boolean{
    if( sessionStorage.getItem('step') ) {
      let step = sessionStorage.getItem('step');
      switch(step) {
        case 'opciones/autonomo-thank-you-page': 
          return true;
        break;
        default:
          return false; 
        break;
      }
    } else {
      return false;
    }
  }

}
